module.exports = "../../app/cells/components/campaigns/interventions/modal_side_hero_cell.rb";